import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText } from '@facet-wealth/design';
import HouseholdInfoSectionSnippets from './HouseholdInfoSectionSnippets/HouseholdInfoSectionSnippets';
import HouseholdInfoSectionFamilyMembers from './HouseholdInfoSectionFamilyMembers/HouseholdInfoSectionFamilyMembers';
import HouseholdInfoSectionClients from './HouseholdInfoSectionClients/HouseholdInfoSectionClients';

const HouseholdInfoSectionMetaOverride = buildFacetDesignOverride()
  .nameOverride(['householdId', 'timezone', 'location'], {
    _component: () => FDBodyText,
    _customProps: { size: 'sm' },
  }, overrideReadOnly)
  .nameOverride('snippets', {
    _component: () => HouseholdInfoSectionSnippets,
  }, overrideReadOnly)
  .nameOverride('familyMembers', {
    _component: () => HouseholdInfoSectionFamilyMembers,
  }, overrideReadOnly)
  .nameOverride('clients', {
    _component: () => HouseholdInfoSectionClients,
  }, overrideReadOnly);

export default HouseholdInfoSectionMetaOverride;
